import React from 'react';
import { TokenSent } from '../Presentation';

export const TokenSentConatiner: React.FC = () => {
  return <TokenSent />;
};
